import { Popup, PopupPanel, DropDownSelector } from 'component/popup';
import { UtilityText } from 'component/text';
import { component, componentWithVariants, demoFile, story, CLICK, CHECK_TEXT, variant } from 'system/demo';

demoFile('component/popup');

function PopupPanelDemo({testID, alignRight, popupContent, label}) {
    return (
        <PopupPanel testID={testID} alignRight={alignRight} popupContent={popupContent}>
            <UtilityText text={label} />
        </PopupPanel>
    );
}

componentWithVariants('PopupPanel', PopupPanelDemo, {}, [
    variant('Default', {
        args: {
            testID: 'popup-panel',
            label: 'Open Popup',
            popupContent: () => <UtilityText text='Popup content' />,
            alignRight: false
        }
    }, [
        story('Open', [CLICK('popup-panel'), CHECK_TEXT('Popup content')]),
        story('Open and Close', [CLICK('popup-panel'), CLICK('popup-panel'), CHECK_TEXT('Open Popup')])
    ]),
    variant('Align Right', {
        args: {
            testID: 'popup-right',
            label: 'Open Right Popup',
            popupContent: () => <UtilityText text='Right popup' />,
            alignRight: true
        }
    }, [
        story('Show Right', [CLICK('popup-right'), CHECK_TEXT('Right popup')])
    ])
]);

componentWithVariants('DropDownSelector', DropDownSelector, {
    args: {
        options: [{key:'a', label:'!A'}, {key:'b', label:'!B'}],
        value: 'a',
        onChange: () => {}
    }
}, [
    variant('Default', {args:{testID:'dropdown', text:'Sort'}}, [
        story('Select', [CLICK('dropdown'), CLICK('!B')])
    ]),
    variant('No Label', {args:{testID:'dropdown-none'}}, [
        story('Open Menu', [CLICK('dropdown-none'), CHECK_TEXT('B')])
    ])
]);

function PopupDemo() {
    return <Popup testID='popup-base' popupContent={() => <UtilityText text='Base popup' />}>
        <UtilityText text='Open Base Popup'/>
    </Popup>;
}

component('Popup', PopupDemo, {}, [story('Basic', [CLICK('popup-base'), CHECK_TEXT('Base popup')])]);
